import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import '@morefunos/ui/tokens.css';
import '@morefunos/ui/base.css';
import './owner.css';
import {App} from './App.tsx';
import {createOwnerReportingPort} from './owner-reporting-port.ts';
import {resolveOwnerRuntimeHost} from './runtime.ts';

const root = document.getElementById('root');
if (!root) throw new Error('OWNER_ROOT_REQUIRED');
const host = resolveOwnerRuntimeHost();
const port = host ? createOwnerReportingPort(host.runtime, {
  actorId: host.actorId,
  businessDate: host.businessDate,
  now: host.now ?? (() => new Date().toISOString()),
}) : null;

createRoot(root).render(<StrictMode><App port={port} /></StrictMode>);
